import { render, staticRenderFns } from "./suggestion.vue?vue&type=template&id=1ac9ce9a&scoped=true&"
import script from "./suggestion.vue?vue&type=script&lang=js&"
export * from "./suggestion.vue?vue&type=script&lang=js&"
import style0 from "./suggestion.vue?vue&type=style&index=0&id=1ac9ce9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac9ce9a",
  null
  
)

export default component.exports